module.exports = __webpack_public_path__ + "static/media/mf.72828f0e.svg";